// todo: use a generic ticker instead of the specific requestAnimationFrame method?
import easing from "easing";

const DURATION = 1000,
    MAX = 0.8,
    EASING = easing.easeOutQuad;

export let scrollTo = (element, OFFSET) => {
    let _OFFSET = 0;
    let t_clientHeight = 0;
    let t_extra = 0;
    let _quicklinklistSticky = null;
    let _headerBar = document.querySelector(".header-bar");
    let h_clientHeight;

    let _quicklinklist = document.querySelector(".quicklinklist.stickable");
    if (_quicklinklist !== null) {
        let _quicklinklistClone = _quicklinklist.cloneNode(true);
        _quicklinklistClone.classList.add("sticky");
        _quicklinklistClone.style.opacity = 0;
        document.body.appendChild(_quicklinklistClone);
        t_clientHeight = _quicklinklistClone.clientHeight;
        document.body.removeChild(_quicklinklistClone);

        _quicklinklistSticky = document.querySelector(".quicklinklist.sticky");

        if (_quicklinklistSticky === null) {
            if (_headerBar.classList.contains("sticky")) {
                t_extra = _headerBar.clientHeight + 50;
            } else {
                t_extra = 50;
            }
        } else {
            t_extra = 0;
        }
    } else {
        t_clientHeight = 0;
    }

    if (_headerBar === null) {
        h_clientHeight = 0;
    } else {
        h_clientHeight = _headerBar.clientHeight;
    }

    if (element.getBoundingClientRect().top > 0) {
        //scroll down;
        _OFFSET = t_clientHeight + t_extra + 25;
    } else {
        //scroll up
        _OFFSET = h_clientHeight + t_clientHeight + 25;
    }

    let scrollY = window.scrollY || window.pageYOffset,
        scrollTargetY = element.getBoundingClientRect().top + scrollY - _OFFSET,
        current = 0,
        time = Math.max(
            0.1,
            Math.min(Math.abs(scrollY - scrollTargetY) / DURATION, MAX)
        );

    let tick = () => {
        current += 1 / 60;

        let p = current / time;

        if (p < 1) {
            window.requestAnimationFrame(tick);
            window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * EASING(p));
        } else {
            window.scrollTo(0, scrollTargetY);
        }
    };

    tick();
};
